"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Activities = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Activities = function Activities() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    d: "M4.73684 10.8L11.3947 0L18.0526 10.8H4.73684Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M12.6053 18.6C12.6053 15.612 15.0384 13.2 18.0526 13.2C21.0668 13.2 23.5 15.612 23.5 18.6C23.5 21.588 21.0668 24 18.0526 24C15.0384 24 12.6053 21.588 12.6053 18.6Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M10.1842 23.4H0.5V13.8H10.1842V23.4Z",
    fill: "currentColor"
  }));
};

exports.Activities = Activities;